import styled from 'styled-components';

const VSpacer = styled.div`
	height: ${({ height }) => (height ? height : '60px')};
	width: 100%;
`;

export default VSpacer;
